import React from 'react';

import { Tooltip } from 'antd';

import { isOlderThan } from '@libs/NwMoment';

import NwIcon from '@components/Gui/NwIcon';

import { FeatureGroupContent, FeatureGroupMetrics } from './FeaturesGroupFeatureDisplay';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const contentProps = (ctx) => ({
    breakpoints: ctx.breakpoints,
    featuresIndex: ctx.featuresIndex,
    gender: ctx.gender,
    getMetricIndex: ctx.getMetricIndex,
    onMetricChange: ctx.onMetricChange,
    onEditFeature: ctx.onEditFeature,
});

const FeaturesGroupDesktopFeatureBox = ({
    item,
    feature,
    isActive,
    itemSpan,
    publicFeature,
    showInlinePublicValue,
    conversionSortedValues,
    conversionMetricIndex,
    historyTooltipTitle,
    ctx,
}) => {
    const cp = contentProps(ctx);

    return (
        <div
            className={`feature-box span-${itemSpan} feature-${item.Feature.TypeName.toLowerCase()} ${isActive ? 'active' : ''} ${
                publicFeature ? 'has-public-value' : ''
            } ${showInlinePublicValue ? 'has-inline-public-value' : ''}`}
        >
            <div className="feature-box-header">
                <span>{item.Feature.Name}</span>
                {feature.DateModified || feature.DateCreated ? (
                    <Tooltip
                        title={historyTooltipTitle}
                        arrowPointAtCenter={true}
                        placement="bottomRight"
                    >
                        <NwIcon
                            icon={byPrefixAndName.fasl['clock-rotate-left']}
                            pointer
                            danger={isOlderThan(feature.DateModified || feature.DateCreated, 6)}
                        />
                    </Tooltip>
                ) : (
                    <Tooltip title="No information available" arrowPointAtCenter={true} placement="bottomRight">
                        <NwIcon disabled icon={byPrefixAndName.fasl['clock-rotate-left']} pointer />
                    </Tooltip>
                )}
            </div>
            <div className="feature-box-content">
                {showInlinePublicValue ? (
                    <div className="feature-inline-values">
                        <FeatureGroupContent
                            feature={feature}
                            itemFeature={item.Feature}
                            featureName={item.Feature.Name}
                            showMetrics={false}
                            {...cp}
                        />
                        <span className="feature-inline-separator">&bull;</span>
                        <FeatureGroupContent
                            feature={publicFeature}
                            itemFeature={item.Feature}
                            featureName={item.Feature.Name}
                            isPublicValue
                            showMetrics={false}
                            {...cp}
                        />
                    </div>
                ) : (
                    <>
                        <FeatureGroupContent
                            feature={feature}
                            itemFeature={item.Feature}
                            featureName={item.Feature.Name}
                            showMetrics={!publicFeature}
                            {...cp}
                        />
                        {publicFeature && (
                            <FeatureGroupContent
                                feature={publicFeature}
                                itemFeature={item.Feature}
                                featureName={item.Feature.Name}
                                isPublicValue
                                showMetrics={false}
                                {...cp}
                            />
                        )}
                    </>
                )}
                {conversionSortedValues && (
                    <FeatureGroupMetrics
                        sortedValues={conversionSortedValues}
                        itemFeature={item.Feature}
                        metricIndex={conversionMetricIndex}
                        onMetricChange={ctx.onMetricChange}
                    />
                )}
            </div>
        </div>
    );
};

export default FeaturesGroupDesktopFeatureBox;
